export const INLINE_ENTITY_ELEMENT = "entity";
